import { Outlet, useParams } from "react-router-dom";

import { Loading } from "src/common/Loading";
import PageHeaderError from "src/common/PageHeaderError";
import { useCellKitQuery } from "src/routes/ProductUnits/CellKits/queries";

export const CellKit = () => {
  const { id } = useParams() as { id: string };
  const query = useCellKitQuery(id);

  if (query.isError) {
    return (
      <PageHeaderError
        statusCode={query.error.response.status}
        statusText={query.error.response.statusText}
      />
    );
  }

  if (query.isLoading || !query.isSuccess) {
    return <Loading />;
  }

  return <Outlet />;
};
